import React, { useState } from 'react';

import PropTypes from 'prop-types';

import Overlay from './overlay';

const DisableButton = ({ name, fetchData, isDeleted }) => {
  const [inDisableMode, setInDisableMode] = useState(false);

  return (
    <>
      <button
        className="disableButtonMain"
        type="button"
        onClick={() => {
          setInDisableMode(true);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1}
          stroke="currentColor"
          className="disableButton"
        >
          {isDeleted ? (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          ) : (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
            />
          )}
        </svg>
      </button>
      {inDisableMode && (
        <Overlay
          name={name}
          fetchData={fetchData}
          isDeleted={isDeleted}
          setInDisableMode={setInDisableMode}
        />
      )}
    </>
  );
};

DisableButton.propTypes = {
  name: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  isDeleted: PropTypes.bool.isRequired
};

export default DisableButton;
